import React from 'react';
import { GeneratorConfig } from '../App';

interface SelectorProps {
  config: GeneratorConfig;
  onConfigChange: (config: Partial<GeneratorConfig>) => void;
  onGenerate: () => void;
}

function Selector({ config, onConfigChange, onGenerate }: SelectorProps) {
  return (
    <div className="selector-container">
      <div className="range-group">
        <label className="input-label">Zakres: {config.minRange} - {config.maxRange}</label>
        <div className="range-slider-wrapper">
          <input
            type="range"
            min="1"
            max="99"
            value={config.minRange}
            onChange={(e) => {
              const newMin = parseInt(e.target.value);
              if (newMin < config.maxRange) {
                onConfigChange({ minRange: newMin });
              }
            }}
            className="range-slider range-slider-min"
          />
          <input
            type="range"
            min="2"
            max="100"
            value={config.maxRange}
            onChange={(e) => {
              const newMax = parseInt(e.target.value);
              if (newMax > config.minRange) {
                onConfigChange({ maxRange: newMax });
              }
            }}
            className="range-slider range-slider-max"
          />
          <div className="range-track" />
        </div>
      </div>

      <div className="input-row">
        <div className="input-group input-group-half">
          <label htmlFor="numberCount" className="input-label">
            Ile liczb:
          </label>
          <input
            id="numberCount"
            type="number"
            className="input-field"
            min="1"
            max={config.maxRange - config.minRange + 1}
            value={config.numberCount}
            onChange={(e) => onConfigChange({ numberCount: parseInt(e.target.value) })}
          />
        </div>

        <div className="input-group input-group-half">
          <label htmlFor="repeatCount" className="input-label">
            Ile zestawów:
          </label>
          <input
            id="repeatCount"
            type="number"
            className="input-field"
            min="1"
            max="100"
            value={config.repeatCount}
            onChange={(e) => onConfigChange({ repeatCount: parseInt(e.target.value) })}
          />
        </div>
      </div>

      <button className="generate-button" onClick={onGenerate}>
        Losuj
      </button>
    </div>
  );
}

export default Selector;